import React, { Component } from 'react';
import classNames from 'classnames';

function OptionItem(props) {
  return <option value={props.name} disabled={props.disabled}>{props.name}</option>
}

function SelectOptions(props) {

  const items = props.items;

  const optionItems = items.map((item) => <OptionItem key={item.id} name={item.id} disabled={item.disabled}/> )

  return (
      <select className="listSelect" name={props.name} onChange={props.onChange} defaultValue={props.selected}>
        {optionItems}
      </select>
  )
}

class ListSelect extends Component {

  render() {

    let wrapClass = classNames({
      'control-wrap': true,
      'list-select': true,
      'do-half': this.props.doHalf
    })

    return (
      <div className={wrapClass}>
        <span className="control-label">{this.props.name}{/*<span className="sub-label">{this.props.select}</span>*/}</span>
        <SelectOptions name={this.props.name} items={this.props.items} onChange={this.props.onChange} selected={this.props.select}/>
      </div>
    )
  }
}

export default ListSelect;



// WEBPACK FOOTER //
// ./src/controls/ListSelect.jsx